export default __webpack_public_path__ + "2ff21213cfe9d7f9a82ec5435e760030.svg";